import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisationId String
 * @param assetId String
 * @param reason String
 * @param blockUI boolean
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId, assetId, reason, blockUI) {
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_ARCHIVE, {
        organisationId: organisationId,
        assetId: assetId
    });
    var request = new Request({
        method: Methods.POST,
        url: url,
        withCredentials: true,
        blockUI: blockUI,
        data: { reason: reason }
    });
    return request.execute();
});
